import { render, staticRenderFns } from "./Photoswipe.vue?vue&type=template&id=077f033a&scoped=true"
import script from "./Photoswipe.vue?vue&type=script&lang=js"
export * from "./Photoswipe.vue?vue&type=script&lang=js"
import style0 from "./Photoswipe.vue?vue&type=style&index=0&id=077f033a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f033a",
  null
  
)

export default component.exports